import React from 'react'
import { useTranslation } from "react-i18next"
import { Dialog } from '@progress/kendo-react-dialogs'
import { Grid } from '@material-ui/core'
import './dialog-timer-sign-off.css'

/* === Custom component title for dialog === */
const CustomTimerSignOffTitleBar = (props) => {
    const { t } = useTranslation()
    const customTitleBarStyles = {
        color: '#FFFFFF',
        fontSize: '17px',
        textAlign: 'left',
        paddingTop: '5px',
        fontFamily: 'Ubuntu, sans-serif',
    }
    return (<div style={customTitleBarStyles}><span>{t('dialogTimeSignOff.titleDialogTimerSignOff')}</span></div>)
}


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const DialogTimerSignOff = (props) => {
    const { t } = useTranslation()

    const containerLabelMessage = {
        textAlign: 'center',
        marginTop: '8px'
    }

    const containerButtonsGroupStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px'
    }

    return (
        <div>
            {props.visibleDialogTimerSignOff &&
                <Dialog title={<CustomTimerSignOffTitleBar />} height={247} onClose={props.toggleDialogTimerSignOff}>
                    {/* Container global */}
                    <Grid container style={{ maxWidth: '350px' }} xs={12} lg={12} md={12} sm={12} es={12}>
                        {/* Label y TextArea */}
                        <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={containerLabelMessage}>
                            <p>{t('dialogTimeSignOff.labelTheSesionWillExpireIn')} {props.timeRemaining} {t('dialogTimeSignOff.labelSeconds')}, {t('dialogTimeSignOff.labelWoludYouContinueWorking')}</p>
                        </Grid>

                        {/* Grupo de botones */}
                        <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={containerButtonsGroupStyles}>
                            <span className="dialog-timer-sign-off-button-close" onClick={props.onSignOffByUser}>
                                {t('dialogTimeSignOff.buttonSignOff')}
                            </span>
                            <span className="dialog-timer-sign-off-button-continue" onClick={props.onRefreshUserToken}>
                                {t('dialogTimeSignOff.buttonContinue')}
                            </span>
                        </Grid>
                    </Grid>
                </Dialog>
            }
        </div>
    )
}

export { DialogTimerSignOff as default }